import type {
  GuidedBloodPressureRange,
  GuidedValidationPartResult,
  GuidedValidationResult,
} from '../types/guided-mode.types'

export type BloodPressurePart = 'systolic' | 'diastolic'

const {
  validateBloodPressure,
  validateObservationValue,
} = require('@shared/clinical-logic/helpers/observationRangeValidation.js')

export function validateBloodPressurePart(
  ranges: GuidedBloodPressureRange | null,
  part: BloodPressurePart,
  value: string,
): GuidedValidationPartResult | null {
  if (value === '') return null
  if (!/^\d+$/.test(value)) {
    return { severity: 'blocking', code: 'invalid_format', value }
  }
  return validateObservationValue(ranges?.[part], value) as GuidedValidationPartResult
}

export function validateGuidedBloodPressure(
  ranges: GuidedBloodPressureRange | null,
  systolic: string,
  diastolic: string,
): GuidedValidationResult | null {
  const systolicResult = validateBloodPressurePart(ranges, 'systolic', systolic)
  const diastolicResult = validateBloodPressurePart(ranges, 'diastolic', diastolic)
  const invalidPart = [systolicResult, diastolicResult].find(result => (
    result?.severity === 'blocking' || result?.severity === 'unconfigured'
  ))
  if (invalidPart) return { ...invalidPart, value: `${systolic}/${diastolic}` }
  if (!systolic || !diastolic) return null

  return validateBloodPressure(
    ranges,
    `${Number(systolic)}/${Number(diastolic)}`,
  ) as GuidedValidationResult
}
